import cn from 'classnames';
import T from 'prop-types';
import React, { useContext } from 'react';

import { useSelector } from 'react-redux';
import useBreakpoint from '../../hooks/useBreakpoint';
import { LayoutContext } from '../LayoutContext';
import FileManagerFallbackArrow from './FileManagerFallbackArrow';
import EmptyState from '../../components/common/EmptyState';

export default function FileManagerFallbackOverlay({ show, isArrowVisible }) {
  const { sideNav } = useSelector((state) => ({
    sideNav: state.layout.sideNav,
  }));

  const isFallbackArrowVisibleForBreakpoint = useBreakpoint(['lg', 'xl']);

  const { startNewProjectRef } = useContext(LayoutContext);

  return (
    <div
      id='file-manager-fallback-overlay'
      className={cn('file-manager-fallback-overlay', show && 'show')}
    >
      <FileManagerFallbackArrow
        show={
          !!(
            isFallbackArrowVisibleForBreakpoint &&
            sideNav.isVisible &&
            show &&
            isArrowVisible
          )
        }
        referenceElement={startNewProjectRef}
      />

      <EmptyState className='mt-0 h-100 justify-content-center' />
    </div>
  );
}

FileManagerFallbackOverlay.propTypes = {
  show: T.bool.isRequired,
  isArrowVisible: T.bool,
};
